import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class DataCenterProcess extends EntityBase {
  public MainMenuCaption: string;
  public MenuCaption: string;
  public MainTableName: string;
  public TransferKindId: number;
  public TransferKindTitle: string;
  public HasOppositeBranch: boolean;
  public TransferKindCode?: number;
  public Entity?: string;
  public EntityName?: string;
}
